<template>
  <el-dialog title="序列号明细" :visible.sync="isShow" width="700px" @close="closeDialog">
    <div v-loading="isLoading">
      <el-table :data="tableList" border>
        <el-table-column type="index" width="70" label="序号" />
        <el-table-column prop="sellTime" label="出货日期" align="left" />
        <el-table-column prop="productName" label="产品名称" align="left" />
        <el-table-column prop="barcodeNumber" label="序列号" align="left" />
      </el-table>
    </div>
  </el-dialog>
</template>
<script type="es6">
import { getSerialNumberListByContract } from '@/API';
export default {
  data () {
    return {
      isShow: false,
      isLoading: false,
      tableList: []
    };
  },
  methods: {
    openDialog (strContractCode, productName, specialProductList) {
      this.tableList = [];
      this.isLoading = true;
      this.isShow = true;
      getSerialNumberListByContract(strContractCode, productName, specialProductList).then((res) => {
        let json = res.data;
        this.isLoading = false;
        if (json.status === '200') {
          this.tableList = json.data;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },

    closeDialog () {
      this.tableList = [];
      this.isShow = false;
    }
  }

};
</script>
